namespace $ {
	$mol_style_define( $shm_agent_history, {
		Catalog: {
			flex: { basis: '24rem', grow: 0, shrink: 0 },
			minWidth: '20rem',
			Body_content: { padding: 0, minHeight: 0 },
		},
		Catalog_list: {
			flex: { direction: 'column' },
		},
		Catalog_link: {
			flex: { direction: 'column' },
			align: { items: 'stretch' },
			padding: $mol_gap.text,
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Catalog_text: {
			lineHeight: '1.25rem',
			maxHeight: '2.5rem',
			overflow: 'hidden',
			whiteSpace: 'pre-wrap',
		},
		Catalog_time: { color: $mol_theme.shade, font: { size: '0.75rem' } },
		Catalog_more: { justifyContent: 'center' },
		Catalog_empty: { padding: $mol_gap.block, color: $mol_theme.shade },
		Detail: {
			flex: { basis: '38rem', grow: 1, shrink: 0 },
			minWidth: '28rem',
			Body_content: { padding: 0, minHeight: 0, height: '100%', maxHeight: '100%' },
		},
		Detail_body: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			height: '100%',
			minHeight: 0,
			overflow: 'hidden',
		},
		User_panel: {
			flex: { direction: 'column', grow: 0, shrink: 1, basis: 'auto' },
			maxHeight: '20%',
			minHeight: 0,
			border: { bottom: { width: '2px', style: 'solid', color: $mol_theme.line } },
			overflow: 'hidden',
		},
		Previous_panel: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			minHeight: 0,
			border: { bottom: { width: '2px', style: 'solid', color: $mol_theme.line } },
			overflow: 'hidden',
		},
		Last_panel: {
			flex: { direction: 'column', grow: 0, shrink: 1, basis: 'auto' },
			maxHeight: '40%',
			minHeight: 0,
			overflow: 'hidden',
		},
		User_scroll: {
			flex: { shrink: 1 },
			minHeight: 0,
			overflow: { y: 'auto' },
		},
		User_messages: {
			flex: { direction: 'column' },
			padding: { top: '0.5rem', right: $mol_gap.text, bottom: $mol_gap.block },
		},
		Previous_list: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: 0,
			overflow: { y: 'auto' },
		},
		Previous_messages: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			padding: { top: '0.5rem', right: $mol_gap.text, bottom: $mol_gap.block },
		},
		Last_scroll: {
			flex: { shrink: 1 },
			minHeight: 0,
			overflow: { y: 'auto' },
		},
		Last_messages: {
			flex: { direction: 'column' },
			padding: { top: '0.5rem', right: $mol_gap.text, bottom: $mol_gap.block },
		},
		No_previous: { padding: $mol_gap.block, color: $mol_theme.shade },
		No_answers: { padding: $mol_gap.block, color: $mol_theme.shade },
		'@media': {
			'(max-width: 640px)': {
				Catalog: { width: '100%', minWidth: '100%', flex: { basis: '100%', grow: 1, shrink: 1 } },
				Detail: { width: '100%', minWidth: '100%', flex: { basis: '100%', grow: 1, shrink: 1 } },
			},
		},
	} )

}
